// =========================================================
// * Vue Now UI Dashboard PRO - v2.0.0
// =========================================================
//
// * Product Page: http://www.creative-tim.com/product/vue-now-ui-dashboard-pro
// * Copyright 2019 Creative Tim (http://www.creative-tim.com)
//
// * Designed by www.invisionapp.com Coded by www.creative-tim.com
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import { createApp } from "vue";
import Antd from 'ant-design-vue';
import firebase from 'firebase/app'

import App from "./App.vue";
import router from "./router";

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'ant-design-vue/dist/antd.css';

import DashboardPlugin from "./dashboard-plugin";

const options = { containerClassName: "ct-notification" };

const config = {
    apiKey: 'AIzaSyDOQgU5fP874AFR8YUd7pzPxz1Smj3ivtQ',
    authDomain: 'richman-shop.firebaseapp.com',
    databaseURL: 'https://richman-shop.firebaseio.com',
    projectId: 'richman-shop',
    storageBucket: 'richman-shop.appspot.com',
    messagingSenderId: '50202918879'
};
firebase.initializeApp(config)

const appInstance = createApp(App);
appInstance.use(router);
appInstance.use(Antd);
appInstance.use(Toast, options);
appInstance.use(DashboardPlugin);
appInstance.use(VueAxios, axios)
appInstance.mount("#app");
